import { Box, Spinner, Text } from "@chakra-ui/react";
import Head from "next/head";
import { useRouter } from "next/router";
import { useState } from "react";

import { getApiBaseUrl } from "@/config/config";
import Inicio from "@/sections/disponibilidad/Init";
import Seleccion from "@/sections/disponibilidad/Selection";
import Inicio_v2 from "@/sections/disponibilidad/v2/Init";
import Seleccion_v2 from "@/sections/disponibilidad/v2/Selection";

export async function getServerSideProps(context) {
    const { id } = context.query;
    const url = `${getApiBaseUrl()}/branding/${id}`;
    try {
        const response = await fetch(url, {
            method: "GET",
        });
        const data = await response.json();

        if (data.length > 0) {
            return {
                props: {
                    developmentData: data[0],
                },
            };
        } else {
            return {
                props: {
                    developmentData: "error",
                },
            };
        }
    } catch (error) {
        console.error("Error fetch: ", error);
        return {
            props: {
                developmentData: "error",
            },
        };
    }
}

const DisponibilidadIlustrada = ({ developmentData }) => {
    const router = useRouter();
    const { isEmbedded } = router.query;
    const [isInit, setIsInit] = useState(isEmbedded ? true : false);

    return (
        <div style={{ overflow: "hidden" }}>
            <Head>
                <title>Disponibilidad Ilustrada - Grupo Guía</title>
                <link rel="alternate" hrefLang="es-mx" />
            </Head>
            {developmentData ? (
                <Box minHeight="99vh" maxH={{ base: "100%", md: "100vh" }} maxW="100vw">
                    {developmentData === "error" ? (
                        <Box
                            minHeight="99vh"
                            maxH="99vh"
                            m={2}
                            alignContent="center"
                            justifyContent="center"
                        >
                            <Text textAlign="center">
                                Lo sentimos, la sección de disponibilidad ilustrada aún no está
                                disponible :(
                            </Text>
                        </Box>
                    ) : null}
                    {!isInit && developmentData?.id ? (
                        developmentData?.branding_props?.version === 2 ? (
                            <Inicio_v2
                                branding_props={developmentData.branding_props}
                                setIsInit={setIsInit}
                            />
                        ) : (
                            <Inicio
                                branding_props={developmentData.branding_props}
                                setIsInit={setIsInit}
                            />
                        )
                    ) : developmentData?.branding_props?.version === 2 ? (
                        <Seleccion_v2 developmentData={developmentData} setIsInit={setIsInit} />
                    ) : (
                        <Seleccion developmentData={developmentData} setIsInit={setIsInit} />
                    )}
                </Box>
            ) : (
                <Box
                    minHeight="99vh"
                    maxH="99vh"
                    m={2}
                    alignContent="center"
                    justifyContent="center"
                    w="100%"
                    justifyItems="center"
                    justifySelf="center"
                >
                    <Spinner
                        borderWidth="4px"
                        animationDuration="0.65s"
                        emptyColor="gray.200"
                        color="yellow.300"
                        size="xl"
                    />
                </Box>
            )}
        </div>
    );
};

export default DisponibilidadIlustrada;
